import React from 'react';
import { Divider } from './Divider';
import { InstagramIcon, PhoneIcon, PinIcon } from './icons/Icons';
import { ADDRESS, INSTAGRAM, INSTAGRAM_HREF, LOGO_URL, PHONE_DISPLAY, PHONE_HREF } from '../data/site';
import { useLanguage } from '../data/i18n';
import { LanguageToggle } from './LanguageToggle';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="relative w-full border-t border-white/10 bg-black py-20" data-id="element-43" data-mp="3uf0opddwyguv">
      
    </footer>;
}